import { RequestService, type RequestOptions } from '../request-service';
import type {
  ReportEventRequest,
  ReportEventResponse,
} from '@wix/ambassador-dealer-v1-offer-event/types';
import type RpcModule from '@wix/ambassador-dealer-v1-offer-event/rpc';
import type HttpModule from '@wix/ambassador-dealer-v1-offer-event/http';

type RpcModuleType = typeof RpcModule;
type HttpModuleType = typeof HttpModule;

export class DealerOfferEventService extends RequestService<
  RpcModuleType,
  HttpModuleType
> {
  protected async rpcModule(): Promise<RpcModuleType> {
    return import('@wix/ambassador-dealer-v1-offer-event/rpc');
  }

  protected async httpModule(): Promise<HttpModuleType> {
    return import('@wix/ambassador-dealer-v1-offer-event/http');
  }

  async reportEvent(
    payload: ReportEventRequest,
    options?: RequestOptions,
  ): Promise<ReportEventResponse> {
    return this.request<ReportEventRequest, ReportEventResponse>({
      methodName: 'reportEvent',
      payload,
      options,
    });
  }
}
